var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.908,
    height: 15.911,
    viewBox: "0 0 15.908 15.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M16.316,4.678a5.814,5.814,0,0,0-.37-1.93A4.076,4.076,0,0,0,13.618.42a5.829,5.829,0,0,0-1.93-.37C10.836.009,10.566,0,8.406,0S5.975.009,5.126.047A5.816,5.816,0,0,0,3.2.416a3.882,3.882,0,0,0-1.411.92A3.917,3.917,0,0,0,.868,2.745,5.83,5.83,0,0,0,.5,4.675C.458,5.527.449,5.8.449,7.957S.458,10.388.5,11.236a5.814,5.814,0,0,0,.37,1.93,4.075,4.075,0,0,0,2.328,2.328,5.83,5.83,0,0,0,1.93.37c.848.037,1.119.047,3.279.047s2.431-.009,3.279-.047a5.813,5.813,0,0,0,1.93-.37,4.07,4.07,0,0,0,2.328-2.328,5.834,5.834,0,0,0,.37-1.93c.037-.849.047-1.119.047-3.279s0-2.431-.04-3.279Zm-1.433,6.5a4.361,4.361,0,0,1-.274,1.476A2.639,2.639,0,0,1,13.1,14.161a4.377,4.377,0,0,1-1.476.273c-.839.037-1.091.047-3.214.047s-2.378-.009-3.214-.047a4.359,4.359,0,0,1-1.476-.273,2.448,2.448,0,0,1-.914-.594,2.474,2.474,0,0,1-.594-.914,4.377,4.377,0,0,1-.273-1.476c-.037-.839-.047-1.091-.047-3.214s.009-2.378.047-3.214a4.359,4.359,0,0,1,.273-1.476,2.418,2.418,0,0,1,.6-.914,2.47,2.47,0,0,1,.914-.594A4.38,4.38,0,0,1,5.2,1.492c.839-.037,1.091-.047,3.214-.047s2.378.009,3.214.047a4.361,4.361,0,0,1,1.476.274,2.447,2.447,0,0,1,.914.594,2.473,2.473,0,0,1,.594.914,4.379,4.379,0,0,1,.274,1.476c.037.839.047,1.091.047,3.214s-.009,2.372-.047,3.211Zm0,0",
    transform: "translate(-0.449 0)",
    fill: "#b07f4a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M129.036,124.5a4.087,4.087,0,1,0,4.087,4.087A4.088,4.088,0,0,0,129.036,124.5Zm0,6.739a2.651,2.651,0,1,1,2.651-2.651A2.652,2.652,0,0,1,129.036,131.239Zm0,0",
    transform: "translate(-121.079 -120.63)",
    fill: "#b07f4a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M364.358,89.556a.954.954,0,1,1-.954-.954A.954.954,0,0,1,364.358,89.556Zm0,0",
    transform: "translate(-351.198 -85.848)",
    fill: "#b07f4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.14ae22713a4390b1f50e61fc5755f687.svg";
export { ForwardRef as ReactComponent };